import { render, staticRenderFns } from "./c_radio.vue?vue&type=template&id=36b531da&scoped=true"
import script from "./c_radio.vue?vue&type=script&lang=js"
export * from "./c_radio.vue?vue&type=script&lang=js"
import style0 from "./c_radio.vue?vue&type=style&index=0&id=36b531da&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b531da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chillzon/Documents/projects/crmeb_view/mer_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36b531da')) {
      api.createRecord('36b531da', component.options)
    } else {
      api.reload('36b531da', component.options)
    }
    module.hot.accept("./c_radio.vue?vue&type=template&id=36b531da&scoped=true", function () {
      api.rerender('36b531da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobileConfigRight/c_radio.vue"
export default component.exports